export default __webpack_public_path__ + "static/media/2369.0c58b03d.png";